export const ENVIRONMENT = process.env.QC_ENVIRONMENT || 'local'
export const VERSION = process.env.QC_VERSION || 'local'
export const API_URL =
  process.env.QC_API_URL || 'https://api.stag.quickcheckoutpage.com/v1'
